import http from '../../utils/fetch';
export default {
    //分页查询收货单位信息
    selectPage(query){
        return http({
            url: 'api/swyl/v1/basic/bscAddrData/selectPage',
            method: 'post',
            params: query
        });
    },
    //单条查看
    selectById(query) {
        return http({
            url: 'api/swyl/v1/basic/bscAddrData/selectById?id='+query,
            method: 'post',
            params: query
        });
    },
    //根据流程实例id单条查看
    selectByInstid(query) {
        return http({
            url: 'api/swyl/v1/basic/bscAddrData/selectByInstid?instid='+query,
            method: 'post',
            params: query
        });
    },
    //新增收货单位
    insertAddress(query) {
        return http({
            url: 'api/swyl/v1/basic/bscAddrData/insertAddress',
            method: 'post',
            data: query
        });
    },
    //修改收货单位
    updateAddress(query) {
        return http({
            url: 'api/swyl/v1/basic/bscAddrData/updateAddress',
            method: 'post',
            data: query
        });
    },
    //审批通过
    approveAddress(query) {
        return http({
            url: 'api/swyl/v1/basic/bscAddrData/approveAddress',
            method: 'post',
            params: query
        });
    },
    //驳回
    rejectAddress(query) {
        return http({
            url: 'api/swyl/v1/basic/bscAddrData/rejectAddress',
            method: 'post',
            params: query
        });
    },
    //根据流程实例id单条查看
    getDeptList(query) {
        return http({
            url: 'api/swyl/v1/basic/bscAddrData/getAddrListByWl?deptName='+query,
            method: 'post',
            params: query
        });
    },

    //根据企业全名或注册号获取企业联系信息
    getTelByWl(query) {
        return http({
            url: 'api/swyl/v1/basic/bscAddrData/getTelByWl?deptName='+query,
            method: 'post',
            params: query
        });
    },

    //获取父级编码
    getParentInfo(query){
        return http({
           url: 'api/swyl/v1/basic/bscAddrData/getAllDeptByCode',
            method: 'post',
            params: query
        });
    },
    //用户单位二级分类,按照渠道编码查询
    getAddressTypeByChannel(query){
        return http({
            url: 'api/swyl/v1/demo/bscAddressType/getAddressTypeByChannel?channel='+query,
            method: 'post',
        });
    },
    //用户单位二级分类,按照渠道编码查询
    getAddressTypeByChannel2(query){
        return http({
            url: 'api/swyl/v1/demo/bscAddressType/getAddressTypeByChannel2?channel='+query,
            method: 'post',
        });
    },
    //根据企业全名或注册号获取企业联系信息
    getAddressByWl(query) {
        return http({
            url: 'api/swyl/v1/basic/bscAddrData/getAddressDetailByWl?deptName='+query,
            method: 'post',
            params: query
        });
    },
}
